type TemplateListRowProps = {
  name: string;
  selected: boolean;
  onSelect: (name: string) => void;
};

export function TemplateListRow({ name, selected, onSelect }: TemplateListRowProps) {
  return (
    <button
      type="button"
      className={`dem-template-row${selected ? ' dem-template-row--selected' : ''}`}
      onClick={() => onSelect(name)}
    >
      {name}
    </button>
  );
}
